import React, { useEffect, useState } from 'react'

import { CheckboxItemProps } from '../../../common/types'

interface CheckboxGroupProps {
  checkboxes: CheckboxItemProps[]
  isDisabled?: boolean
}

const Checkbox = ({
  checkboxContainerClass = '',
  defaultValue,
  disabled = false,
  id,
  onValueChange,
  title,
}: CheckboxItemProps) => {
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if (defaultValue !== undefined) {
      setIsChecked(defaultValue)
    }
  }, [defaultValue])

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    setIsChecked(checked)
    return onValueChange && onValueChange(checked)
  }

  const inputClasses = [
    'h-4',
    'w-4',
    'border-gray-300',
    'text-indigo-600',
    'focus:ring-indigo-600',
    'disabled:cursor-not-allowed',
    'disabled:text-gray-400',
  ]
  const labelClasses = [
    'ml-3',
    'flex',
    'items-center',
    'text-sm',
    'font-medium',
    'leading-6',
    disabled && 'text-gray-500',
  ]
  if (disabled) {
    labelClasses.push(...['cursor-not-allowed', 'text-gray-400'])
  } else {
    labelClasses.push('text-gray-900')
  }

  return (
    <div className={`flex items-center ${checkboxContainerClass}`}>
      <input
        checked={isChecked}
        className={inputClasses.join(' ')}
        disabled={disabled}
        id={id}
        name={id}
        onChange={handleValueChange}
        type="checkbox"
      />
      <label
        aria-disabled={disabled ? 'true' : 'false'}
        htmlFor={id}
        className={labelClasses.join(' ')}
      >
        {title}
      </label>
    </div>
  )
}

const CheckboxGroup = ({
  checkboxes,
  isDisabled = false,
}: CheckboxGroupProps) => {
  return (
    <fieldset className="flex flex-wrap gap-4">
      {checkboxes.map((checkbox) => (
        <Checkbox key={checkbox.id} {...checkbox} disabled={isDisabled} />
      ))}
    </fieldset>
  )
}

export { Checkbox, CheckboxGroup }

export default Checkbox
